//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import VehicleProvisionSummary from './VehicleProvisionSummary.vue'

export default {
  name: 'VehicleProvisionSummaryView',
  components: {
    VehicleProvisionSummary
  },
  data: function () {
    return {
      loadingFull: false,

      summary: null,
      minimized: false,
      excludePast: false,
      excludeCurrent: false,
      includeFutureCount: null
    }
  },
  created: function () {
    const query = this.$route.query
    if (query && query.minimized) {
      this.minimized = query.minimized === 'true'
    }
    if (query && query.excludePast) {
      this.excludePast = query.excludePast === 'true'
    }
    if (query && query.excludeCurrent) {
      this.excludeCurrent = query.excludeCurrent === 'true'
    }
    if (query && query.includeFutureCount) {
      this.includeFutureCount = Number(query.includeFutureCount)
    }

    this.load()
  },
  methods: {
    onReload: function () {
      this.load()
    },
    load: function () {
      this.loadingFull = true
      return axiosGet({
        url: '/service/delta/vehicleProvision/summary',
        onSuccess: response => {
          this.summary = response.data.result
        },
        onFailure: 'Ошибка получения сводки',
        throws: true
      }).finally(() => {
        this.loadingFull = false
      })
    }
  }
}

